import Color from '@/Enums/Color.enum';
import { Paper, SxProps, Theme, Typography } from '@mui/material';
import { ReactNode, memo } from 'react';

interface IProps {
  label: ReactNode;
  value: ReactNode;
  sx?: SxProps<Theme>;
  'aria-label'?: string;
}

const MetricCard = memo(({ label, value, sx, 'aria-label': ariaLabel }: IProps) => (
  <Paper
    aria-label={ariaLabel}
    sx={{
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      paddingY: '8px',
      background: 'white',
      ...sx,
    }}
  >
    <Typography component='p' sx={{ fontWeight: 500, fontSize: '12px', color: Color.Grey }}>
      {label}
    </Typography>
    <Typography component='p' sx={{ fontWeight: 700, fontSize: '30px', color: Color.Primary }}>
      {value}
    </Typography>
  </Paper>
));

export default MetricCard;
